<template>
  <v-row>
    <v-col cols="12">
      <v-row v-if="isLoading">
        <v-col cols="12">
          <v-row
            align="center"
            justify="center"
          >
            <v-progress-circular
              :size="125"
              :width="7"
              color="primary"
              indeterminate
            />
          </v-row>
        </v-col>
      </v-row>
      <v-row v-if="!isLoading">
        <v-col cols="12">
          <v-row>
            <v-col cols="12">
              <tax-rate-select-dialog
                :init-selected="defaultTaxRates"
                @action="onSaveTaxRates"
              >
                <template v-slot:activator="{ on }">
                  <v-btn
                    small
                    text
                    rounded
                    color="primary"
                    v-on="on"
                  >
                    <v-icon small left>gavel</v-icon>

                    Set Default Tax Rates
                  </v-btn>
                </template>
              </tax-rate-select-dialog>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12">
              <timezone-select-dialog
                :init-timezone="defaultTimezone"
                @action="onSaveTimezone"
              >
                <template v-slot:activator="{ on }">
                  <v-btn
                    small
                    text
                    rounded
                    color="primary"
                    v-on="on"
                  >
                    <v-icon small left>tonality</v-icon>

                    Set Default Timezone
                  </v-btn>
                </template>
              </timezone-select-dialog>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>
<script>
import TaxRateSelectDialog from "../TaxRate/TaxRateSelectDialog"
import { mapActions, mapGetters } from 'vuex'

import { get } from 'lodash'
import TimezoneSelectDialog from "../Tenant/TimezoneSelectDialog"

export default {
  components: { TimezoneSelectDialog, TaxRateSelectDialog },
  props: {
    account: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    ...mapGetters(['getActiveTenant'])
  },
  mounted() {
    const metaTaxRates = get(this.account, 'metadata.default_tax_rates', '[]')
    const defaultTaxRates= JSON.parse(metaTaxRates)
    this.defaultTaxRates = defaultTaxRates

    this.defaultTimezone = this.getActiveTenant.timezone
  },
  data() {
    return {
      defaultTaxRates: [],
      defaultTimezone: '',
      isLoading: false
    }
  },
  methods: {
    ...mapActions([ 'updateAccountSettings', 'updateTenant' ]),
    onSaveTaxRates(event) {
      const payload = {
        metadata: {
          default_tax_rates: event.map(e => e.id)
        }
      }

      this.isLoading = true
      this.updateAccountSettings(payload)
        .then(() => {
          this.defaultTaxRates = payload.metadata.default_tax_rates
        })
        .finally(() => {this.isLoading = false})
    },
    onSaveTimezone(event) {
      const payload = {
        timezone: event
      }

      this.isLoading = true
      this.updateTenant(payload)
        .then(() => {
          this.defaultTimezone = event
        })
        .finally(() => {this.isLoading = false})
    }
  }
}
</script>
